import { render, staticRenderFns } from "./message-input-button.vue?vue&type=template&id=f87de320&scoped=true"
import script from "./message-input-button.vue?vue&type=script&lang=ts"
export * from "./message-input-button.vue?vue&type=script&lang=ts"
import style0 from "./message-input-button.vue?vue&type=style&index=0&id=f87de320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87de320",
  null
  
)

export default component.exports